module.exports = __webpack_public_path__ + "img/first-birthday-1-min.0681e0e2.png";